import { render, staticRenderFns } from "./weixiu.vue?vue&type=template&id=08838ef0"
import script from "./weixiu.vue?vue&type=script&lang=js"
export * from "./weixiu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports